import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account/account.service';
// import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { BackService } from 'src/app/services/general/back.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-blast-launching',
  templateUrl: './blast-launching.page.html',
  styleUrls: ['./blast-launching.page.scss'],
})
export class BlastLaunchingPage implements OnInit, OnDestroy {

  constructor(
    private router: Router,
    private userService: UserService,
    private accountService: AccountService,
    // private accountsListService: AccountsListService,
    private backService: BackService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
      
  }

  goBack() {
    this.backService.goBack();
  }

  start() {
    if (this.accountService.accountId) {
      this.router.navigate(['/blast/home']);
    } else if (this.userService?.uid) {
      this.router.navigate(['//tabs-accounts/list/true']);
      // if (this.accountsListService?.userAccountsList?.length) {
      //   this.router.navigate(['/accounts/list']);
      // } else {
      //   this.router.navigate(['/accounts/add']);
      // }
    } else {
      this.router.navigate(['/main']);
    }
  }

}
